module.exports = __webpack_public_path__ + "img/customer-icon-3.87e7e1c5.png";